import { connect } from 'react-redux';
import { switchMajorVersion } from 'store/modules/pageBuilder'; // Action for switching major versions
import {
  getMajorVersions,
  getId,
  getPublishedVersion,
  getSelectedMajorVersion, // Selector for fetching selected major version
} from 'store/modules/pageBuilder';
import VersionDropDownButton from '../components/VersionDropDownButton';

const mapStateToProps = state => ({
  majorVersions: getMajorVersions(state), // Fetch the list of major versions
  pageId: getId(state), // Get the current pageId from Redux state
  publishedVersion: getPublishedVersion(state), // Get the current published version
  selectedMajorVersion: getSelectedMajorVersion(state), // Get the selected major version
});

const mapDispatchToProps = dispatch => ({
  onMajorVersionClick: (pageId, majorVersionId) => {
    if (!pageId || !majorVersionId) return; // Ensure valid inputs
    dispatch(switchMajorVersion(pageId, majorVersionId)); // Dispatch the action
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { majorVersions, pageId, publishedVersion, selectedMajorVersion } = stateProps;
  const { onMajorVersionClick } = dispatchProps;

  return {
    ...ownProps,
    majorVersions,
    publishedVersion, // Pass the publishedVersion prop
    selectedMajorVersion, // Pass the selectedMajorVersion prop
    onMajorVersionClick: majorVersionId => onMajorVersionClick(pageId, majorVersionId, publishedVersion), // Inject pageId dynamically
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(VersionDropDownButton);
